(() => {
  const setup = (root = document) => {
    root.querySelectorAll('[data-open-collection-menu]').forEach((button) => {
      if (button.dataset.navigationReady) return;
      button.dataset.navigationReady = 'true';
      const drawer = document.querySelector('header-drawer');
      const main = drawer?.querySelector('#Details-menu-drawer-container');
      const child = drawer?.querySelector('#HeaderDrawer-collections');
      if (!main || !child) return;
      button.addEventListener('click', () => {
        if (!main.open) main.querySelector(':scope > summary').click();
        if (!child.parentElement.open) child.click();
      });
      const syncExpanded = () => button.setAttribute('aria-expanded', String(main.open && child.parentElement.open));
      main.addEventListener('toggle', syncExpanded);
      child.parentElement.addEventListener('toggle', syncExpanded);
    });
    root.querySelectorAll('.liubai-mega-menu').forEach((details) => {
      if (details.dataset.navigationReady) return;
      details.dataset.navigationReady = 'true';
      const host = details.closest('header-menu');
      const summary = details.querySelector('summary');
      let closeTimer;
      const syncPanel = () => {
        const panel = details.querySelector('.mega-menu__content');
        const bottom = host.closest('.header-wrapper').getBoundingClientRect().bottom;
        panel.style.maxHeight = `${Math.max(160, window.innerHeight - bottom)}px`;
      };
      const close = () => {
        clearTimeout(closeTimer);
        details.open = false;
        summary.setAttribute('aria-expanded', 'false');
      };
      const open = () => {
        syncPanel();
        clearTimeout(closeTimer);
        document.querySelectorAll('.liubai-mega-menu[open]').forEach((other) => {
          if (other !== details) {
            other.open = false;
            other.querySelector('summary').setAttribute('aria-expanded', 'false');
          }
        });
        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
      };
      host.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse' && matchMedia('(min-width: 990px)').matches) open();
      });
      host.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') closeTimer = setTimeout(close, 180);
      });
      details.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(details.open));
        if (details.open) syncPanel();
      });
      window.addEventListener('resize', syncPanel);
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.open) {
          close();
          summary.focus();
          event.stopPropagation();
        }
      });
      document.addEventListener('pointerdown', (event) => {
        if (details.open && !host.contains(event.target)) close();
      });
    });
  };
  setup();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
